import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Plus = ({ size = 16, color, className }: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 2.66602V13.3327M13.3327 7.99935L2.66602 7.99935"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
